import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './acknowlegment.scss'
const Acknowlegment = (props) => {
    const handleAction = (status) => {
        props.setPolicyChecked(status)
        props.setPolicyModal(false)
    }
    return (
        <>
            <Modal show={props.policyModal} size="sm">
                <Modal.Header onClick={() => props.setPolicyModal(false)} closeButton>
                </Modal.Header>

                <Modal.Body>
                    <div className='cancelation-policy-wrapper'>
                        <div className='cancelation-title'>Service Provider Certification Acknowledgement</div>
                        <div className='cancelation-content'>
                            <p>By clicking "Submit," I agree to the following terms:</p>
                            <ul>
                                <li>I confirm that I have reviewed the service provider's professional certifications as displayed on their profile.</li>
                                <li>I understand that the service provider's qualifications have been verified to the best of our ability, but I am responsible for ensuring they meet my specific needs and standards.</li>
                                <li>I acknowledge that the service provider will be caring for my child(ren) and/or home, and I have taken the necessary steps to feel comfortable with their abilities and credentials.</li>
                            </ul>
                        </div>
                        <div className='cancelation-btn-wrap'>
                            <Button variant='outline-primary' onClick={() => handleAction(false)}>Decline</Button>
                            <Button variant='primary' onClick={() => handleAction(true)}>Accept</Button>
                        </div>
                    </div>


                </Modal.Body>


            </Modal>
        </>
    )
}

export default Acknowlegment
